var map = {
	"./adindex-map-logo.svg": "./i/sprite/adindex-map-logo.svg",
	"./advertising-map-2020.svg": "./i/sprite/advertising-map-2020.svg",
	"./becreative.svg": "./i/sprite/becreative.svg",
	"./catzwolf-digital-hover.svg": "./i/sprite/catzwolf-digital-hover.svg",
	"./catzwolf-digital.svg": "./i/sprite/catzwolf-digital.svg",
	"./circle.svg": "./i/sprite/circle.svg",
	"./close.svg": "./i/sprite/close.svg",
	"./easymedia.svg": "./i/sprite/easymedia.svg",
	"./i.svg": "./i/sprite/i.svg",
	"./logo-light.svg": "./i/sprite/logo-light.svg",
	"./minus.svg": "./i/sprite/minus.svg",
	"./notagency.svg": "./i/sprite/notagency.svg",
	"./plus.svg": "./i/sprite/plus.svg",
	"./ppl.svg": "./i/sprite/ppl.svg",
	"./red-digital.svg": "./i/sprite/red-digital.svg",
	"./search.svg": "./i/sprite/search.svg",
	"./smi2.svg": "./i/sprite/smi2.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./i/sprite sync \\.svg$";